<template>
  <div class="wrapper">
      <div class="body">
          <div class="body-box mb20 mt20">
            <div class="text-center">
                <img src="@/assets/cek.png" class="mb20" style="width: 75px;" />
                <span class="block f12 mb20">Pembayaran Telah dibuatkan</span>
                <div class=" mb20 bg-round-blue-o20 p10">
                    <div class="box-horizontal">
                        <span class="text-left">ID Invoice</span>
                        <span class="flex-1 f12 text-right"><strong>#{{data.params.invoice}}</strong></span>
                    </div>
                </div>
                <div class="box mb20 b-1">
                    <span class="text-center block f13 mb10"><strong>Pembayaran <span class="red">BEATCOM RTRW</span> via <span style="text-transform: uppercase;">{{data.params.via}}</span></strong></span>
                    <img src="@/assets/qris.png" class="mb10"  style="width: 70%;" v-show="!data.isBrowser" @click="link.qr()"/>
                    <img :src="data.isBrowserQRString" class="mb10" style="width: 80%;" v-show="data.isBrowser"/>
                    <span class="text-center block mb10" v-show="data.isBrowser"> Pastikan pembayaran an <span class="red">BEATCOM RTRW</span></span>
                    <span class="text-center block mb10" v-show="data.isBrowser"> Screenshot atau Scan dengan dompet digital yang anda gunakan.</span>
                    <span class="text-center block mb10" v-show="!data.isBrowser"> Pastikan pembayaran an <span class="red">BEATCOM RTRW</span></span>
                    <span class="text-center block gray"> Support by QRIS</span>
                </div>
                <button class="btn btn-success w100 mb10"  @click="link.qr()" v-show="!data.isBrowser">Download QR Code</button>
                <button class="btn btn-info w100" @click="link.history()">Beranda</button>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import inter from '@/Interface'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import router from '@/router'

import { qrUrl } from '@/var.js'

export default {
    components: {
        
    },
    setup() {
        const data = reactive({
            params: '',
            qr: '',
            inv: '',
            via: '',
            isBrowser: false,
            isBrowserQRString: ""

        /* modal edit tarif */
        })
        const get = {
            datax: reactive({
                this: '',
                hasil: null
            }),
            qrku() {

                console.log(data.qr);
                
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('Token')
                };
            
                var apiUrl = qrUrl+"generated.php?uid="+sessionStorage.getItem('browserTokenUid')+"&string="+data.qr;

                myGlobal.callUrlManual(datax,apiUrl).then(x => {
                    
                    if (x.status == true) {

                        data.isBrowserQRString = qrUrl+"saved/"+sessionStorage.getItem('browserTokenUid')+".png?t=" + new Date().getTime();
                        
                    } else {
                        
                    }

                })

            },
            list() {
                /*
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('Token')
                };
            
                var apiUrl = inter.KategoriList();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        mainData.data = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
                */
            },
            confirmPembayaran() {

            }
        }

        const link = {
            qr() {
                var datax = {
                    qr: data.qr,
                    invoice: data.inv
                }

                myGlobal.android("qrcok", datax);

                router.push({ 
                    name: 'beranda'
                });
            },
            history() {
                router.push({ 
                    name: 'beranda'
                });
            }
        }
        
        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            data,
            myGlobal,
            inter,
            get,
            redirectx,
            link,
        }

    },
    mounted () {
        this.redirectx.checkApp();

        this.data.params = this.$route.params;
        
        //console.log(JSON.stringify(this.data.params.qr));

        this.data.via = this.$route.params.via;
        this.data.qr = this.$route.params.qr;
        this.data.inv = this.$route.params.invoice;

        this.get.datax.this = this;

        //myGlobal.android("toast", this.$route.params.qr);

        // CEK JIKA DARI BROWSER
        
        myGlobal.android("close", null)

        if (sessionStorage.getItem("browserToken") != null) {
            console.log("dari browser");
            this.data.isBrowser = true;

            this.get.qrku();
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/success/main.vue